export default __webpack_public_path__ + "static/media/gold1.00fd8d67.png";